import {Routes} from '@angular/router';

export const returnmoneyManagementRoutes: Routes = [
  {
    path: 'returnMoneyManagement',
    data: { title: '退款管理' },
    children: [
      {
        path: '',
        loadComponent: () => import('./returnmoney-management.component').then(m => m.ReturnmoneyManagementComponent),
        data: { title: '退款管理' },
      },
      {
        path: 'returnMoneyDetail',
        loadComponent: () => import('./returnmoney-detail/returnmoney-detail.component').then(m => m.ReturnmoneyDetailComponent),
        data: { title: '退款明细' },
      },
      {
        path: 'returnMoneyDetail/:returnMoneyOrderId',
        loadComponent: () => import('./returnmoney-detail/returnmoney-detail.component').then(m => m.ReturnmoneyDetailComponent),
        data: { title: '退款明细' },
      },
    ]
  },
];
